import {DISPLAY_BANNER} from "./types"

export const DisplayBanner = (visible:boolean) => {
    return {
      type: DISPLAY_BANNER,
      payload: visible
    }
}
  